import request from '@/utils/request'

let Ma_roleApi = {

  /*角色列表*/
  list(data) {
    return request._post('/shop/plus.ma_role.Index/index', data);
},
/*添加角色*/
add(data) {
    return request._post('/shop/plus.ma_role.Index/add', data);
},
/*修改角色*/
edit(data) {
    return request._post('/shop/plus.ma_role.Index/edit', data);
},
/*删除角色*/
del(data) {
    return request._post('/shop/plus.ma_role.Index/del', data);
},
/*角色详情*/
detail(data) {
  return request._post('/shop/plus.ma_role.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_role.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_role.Setting/getSetting', data, errorback);
    },
}
export default Ma_roleApi;



// WEBPACK FOOTER //
// ./src/api/ma_role.js